

import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

export default{
components: {
Actionsheet,
Confirm,
Alert
},
data(){
return{
tabsParam:[['联系人',"friend"],['消息',"message"]],
demo:"联系人",
nowIndex:0,//默认第一个tab为激活状态
userImg:"",
groupList:[],
friendList:[],
friendId:"",
massageAll:[],
show:false,
menus:{
delete:"删除",
send:"发送消息"
},
Loop:""
}
},
mounted(){

},
beforeMount(){

this.$vux.loading.show({
text: 'Loading'
})



this.userImg = localStorage.getItem('headImg');
this.toggleTabs(0);


setTimeout(() => {
this.$vux.loading.hide()
}, 1000)
},
methods:{
toggleTabs:function(index){

this.$vux.loading.show({
text: 'Loading'
})

switch (index){
case 0:
this.GetGroupLists();
break;
case 1:
this.GetMassageAlls();


break;
}


this.nowIndex=index;


setTimeout(() => {
this.$vux.loading.hide()
}, 300)
},

foldUnfold:function(){
var test = document.getElementById(event.target.id);
var foldingbox = test.nextElementSibling; 
var foldinglogo = test.firstChild ; 

if(foldingbox.className == "folding-show"){
foldingbox.classList.add("folding-close");
foldingbox.classList.remove("folding-show");
test.style.backgroundColor ="#FFFFFF";
foldinglogo.innerHTML = "▼";
}else if(foldingbox.className == "folding-close"){
foldingbox.classList.add("folding-show");
foldingbox.classList.remove("folding-close");
test.style.backgroundColor ="#EDEDED";
foldinglogo.innerHTML = "▲";
}
},

foldUnfold1:function(){

var winHeight = window.innerHeight;
document.getElementById("massage").style.height = winHeight*0.4+"px";
document.getElementById("massage-details").style.height = winHeight*0.3+"px";

var foldingbox = event.target.nextElementSibling;
var foldinglogo = event.target.firstChild ;
var winHeight = window.innerHeight;
if(foldingbox.className == "folding-show"){
foldingbox.classList.add("folding-close");
foldingbox.classList.remove("folding-show");
event.target.style.backgroundColor ="#FFFFFF";
foldinglogo.innerHTML = "▼";
}else if(foldingbox.className == "folding-close"){
foldingbox.classList.add("folding-show");
foldingbox.classList.remove("folding-close");
event.target.style.backgroundColor ="#EDEDED";
foldinglogo.innerHTML = "▲";
}

},

Actionsheet :function(id){
this.friendId ="";
this.friendId=id;
this.show = true;
},

deleteFriend:function(){
var id = this.friendId;
var deleteSure = confirm("确认删除？");

if(deleteSure){


this.$api.DeleteFriend(id)
.then((data) => {
if(data.data.Status!=0){
return ;
}
this.GetGroupLists();
})
}
},

sendMessage:function(type){
switch(type){
case "now":
var id = event.target.nextElementSibling.innerHTML;
var content = event.target.previousElementSibling.value;
if(content.length == 0){
alert("输入内容为空")
}else{
this.$api.SendMessage(id,content)
.then((data) => {
if(data.data.Status!=0){
return ;
}
this.GetMassageAlls();
var winHeight = window.innerHeight;
document.getElementById("massage").style.height = winHeight*0.4+"px";
document.getElementById("massage-details").style.height = winHeight*0.3+"px";
})
}

break;
case "note":
break;
}



},

GetGroupLists:function(){

this.$api.GetGroupList()
.then((data)=>{
if(data.data.Status!=0){
return ;
}
var json = data.data.Data.rows;
this.groupList = json;

this.friendList = [];
for(var i in json ){
this.GetFriendList(json[i].ID)
}


})
},

GetFriendList:function(id){
this.$api.GetFriendList(id)
.then((data)=>{
if(data.data.Status!=0){
return ;
}
var Friend = new Array();
for(var i in data.data.Data.rows){

var jsonData = {
CareID:data.data.Data.rows[i].CareForUserID,
CareName:data.data.Data.rows[i].CareForUserName,
CareLevel:data.data.Data.rows[i].CareForUserLevel,
CareHeader:data.data.Data.rows[i].CareForUserHeader,
}
Friend.push(jsonData)
}

this.friendList.push({ListID:id,FriendList:Friend});
})
},

GetMassageAlls:function(){
this.$api.GetMassageAll()
.then((data) => {
if(data.data.Status!=0){
return ;
}
this.ArrayOnlyData(data.data.Data.row);
})
},

ArrayOnlyData:function(array){
var list =[];
for(var i in array){
if(list.indexOf(array[i].Userid) < 0){
list.push(array[i].Userid);
}
}
this.massageAll=[];
for(var j in list ){
this.$api.GetMassageSome(list[j])
.then((data) => {

if(data.data.Status!=0){
return ;
}
this.massageAll.push({userid:list[j],data:data.data.Data.row})
})
}

}
},
}



// WEBPACK FOOTER //
// ./src/views/Personal/MyContacts.vue